module.exports = __webpack_public_path__ + "img/logo_feishu.0ab387e8.png";